export enum StatusEnum {
  Active = 0,
  Inactive = 1,
  Deleted = 2,
}

export const StatusEnumLabels: Record<StatusEnum, string> = {
  [StatusEnum.Active]: "Active",
  [StatusEnum.Inactive]: "Inactive",
  [StatusEnum.Deleted]: "Deleted",
};
